import CreateEditBrand from "../presentation/sidebars/CreateEditBrand";
import CreateEditCategory from "../presentation/sidebars/CreateEditCategory";
import CreateEditSalesChannel from "../presentation/sidebars/CreateEditSalesChannel";
import CreateCampaignsSidebar from "../presentation/sidebars/createCampaign/CreateCampaignsSidebar";
import CreateCustomer from "../presentation/sidebars/CreateCustomer";
import CreateEditCustomerRelatedFields from "../presentation/sidebars/CreateEditCustomerRelatedFields";
import CreateEditTag from "../presentation/sidebars/CreateEditTag";
import CreateFunnel from "../presentation/sidebars/CreateFunnel";
import DigitalPaymentModal from "../presentation/modules/DigitalPayments/DigitalPaymentModal";
import FiltersSidebar from "../presentation/sidebars/FiltersSidebar";
import OrdersFiltersSidebar from "../presentation/modules/Orders/components/OrdersFiltersSidebar";
import FunnelFilter from "../presentation/sidebars/FunnelFilter";
import FunnelStep from "../presentation/sidebars/FunnelStep";
import IntegrationVideo from "../presentation/sidebars/IntegrationVideo";
import ManageClientForOrderModal from "../presentation/modules/Orders/ManageClientForOrderModal";
import ManageDeal from "../presentation/sidebars/ManageDeal";
import ManageProductDiscountModal from "../presentation/modules/Orders/ManageProductDiscountModal";
import PaymentLinksModal from "../presentation/modules/inbox/PaymentLinks/PaymentLinksModal";
import SendPDFWithPaymentLinksModal from "../presentation/modules/Orders/components/payment-links/SendPDFWithPaymentLinksModal";
import SendPaymentLinksModal from "../presentation/modules/Orders/components/payment-links/SendPaymentLinksModal";
import SendByModal from "../presentation/modules/Orders/components/payment-links/SendByModal";
import DeliveryProofModal from "../presentation/modules/Orders/components/delivery-status/DeliveryProofModal";
import WebhookModal from "../presentation/modules/Webhooks/components/WebhookModal";
import CreateEditCustomField from "../presentation/sidebars/CreateEditCustomField";
import OrderWsModalProductsMC from "../presentation/modules/inbox/components/OrderWsModalProductsMC";
import NewChat from "../presentation/sidebars/NewChat";
import FastAnswersModal from "../presentation/sidebars/FastAnswersModal";
import WhatsappFlowsModal from "../presentation/sidebars/WhatsappFlowsModal";
import AttachFilesSidebar from "../presentation/sidebars/AttachFilesSidebar";
import LocationPickerSidebar from "../presentation/sidebars/LocationPickerSidebar";
import MiaSourcesResponseSidebar from "../presentation/sidebars/mia/MiaSourcesResponseSidebar";
import CustomerAddressSidebar from "../presentation/sidebars/CustomerAddressSidebar";
import CustomerEventSidebar from "../presentation/sidebars/CustomerEventSidebar";
import InboxScreenSidebar from "../presentation/sidebars/InboxScreenSidebar";
import NewsModal from "../presentation/modules/Dashboard/NewsModal";
import OrderModal from "../presentation/modules/Orders/pages/OrderModal";
import PipedreamActions from "../presentation/sidebars/PipedreamActions";
import SearchProductsModal from "../presentation/modules/Orders/components/search-products/SearchProductsModal";
import SelectCustomerModal from "../presentation/modules/Quotes/modals/SelectCustomerModal";
import SelectQuoteTemplateModal from "../presentation/modules/Quotes/modals/SelectQuoteTemplateModal";
import WsTemplatePreviewModalMC from "../presentation/modules/WsTemplates/WsTemplatePreviewModalMC";
import MessageDetailSidebar from "../presentation/sidebars/MessageDetailSidebar";
import WhatsappFlowDetailModal from "../presentation/sidebars/WhatsappFlowDetailModal";
import WhatsappFlowMappingModal from "../presentation/modules/WhatsappFlows/components/WhatsappFlowMappingModal";

// MIA
import DetailModal from "../presentation/modules/Automations/ChatbotIA/Agents/DetailModal";
import AssignmentsModal from "../presentation/modules/Automations/ChatbotIA/Config/AssignmentsModal";
import BuyIntentionModal from "../presentation/modules/Automations/ChatbotIA/Config/BuyIntentionModal";
import ClientDataModal from "../presentation/modules/Automations/ChatbotIA/Config/ClientDataModal";
import CreateModal from "../presentation/modules/Automations/ChatbotIA/Agents/CreateModal";
import CreateChatbotIAGuides from "../presentation/sidebars/CreateChatbotIAGuides";
import GeneralParametersModal from "../presentation/modules/Automations/ChatbotIA/Config/GeneralParametersModal";
import GoalModal from "../presentation/modules/Automations/ChatbotIA/Config/GoalModal";
import HandoffModal from "../presentation/modules/Automations/ChatbotIA/Config/HandoffModal";
import HistoryDetailModal from "../presentation/modules/Automations/ChatbotIA/History/DetailModal";
import ImproveGuideModal from "../presentation/modules/Automations/ChatbotIA/Guides/ImproveGuideModal";
import InstructionsModal from "../presentation/modules/Automations/ChatbotIA/Config/InstructionsModal";
import InteractionExamplesModal from "../presentation/modules/Automations/ChatbotIA/Config/InteractionExamplesModal";
import PlatformsModal from "../presentation/modules/Automations/ChatbotIA/Config/PlatformsModal";
import ProductModal from "../presentation/modules/Automations/ChatbotIA/Config/ProductModal";
import RestrictionsModal from "../presentation/modules/Automations/ChatbotIA/Config/RestrictionsModal";
import SpecificInstructionsModal from "../presentation/modules/Automations/ChatbotIA/Guides/Types/SpecificInstructionsModal";
import StepByStepModal from "../presentation/modules/Automations/ChatbotIA/Config/StepByStepModal";
import GlobalInstructionModal from "../presentation/modules/Automations/ChatbotIA/Agents/ConversationFlow/GlobalInstructions/components/GlobalInstructionModal";
import GlobalInstructionToolsModal from "../presentation/modules/Automations/ChatbotIA/Agents/ConversationFlow/GlobalInstructions/components/GlobalInstructionToolsModal";
import IntentionTemplateModal from "../presentation/modules/Automations/ChatbotIA/Agents/ConversationFlow/Intentions/components/IntentionTemplateModal";
import MemoryModal from "../presentation/modules/Automations/ChatbotIA/Config/MemoryModal";
import OutboundFollowUpsModal from "../presentation/modules/Automations/ChatbotIA/Config/OutboundFollowUpsModal";
import WhatsappConsolidationModal from "../presentation/modules/Automations/ChatbotIA/Config/WhatsappConsolidationModal";
import WsCallClientListSidebarMC from "../presentation/sidebars/WsCallClientListSidebarMC";
import ViewCallSidebar from "../presentation/sidebars/WsCallClientListSidebarMC/ViewCallSidebar";
import MessagingRuleUpgradeModal from "../presentation/modules/MessagingRules/MessagingRuleUpgradeModal";
import MessagingRuleReassignModal from "../presentation/modules/MessagingRules/MessagingRuleReassignModal";
import CalendarSidebarModuleMC from "../presentation/modules/CalendarEvents/CalendarSidebarModuleMC";

const SIDEBARS = {
  CreateCampaignsSidebar,
  CreateEditBrand,
  CreateEditCategory,
  CreateEditTag,
  CreateEditSalesChannel,
  CreateEditCustomerRelatedFields,
  CreateFunnel,
  FunnelFilter,
  ManageDeal,
  CreateCustomer,
  DigitalPaymentModal,
  FiltersSidebar,
  OrdersFiltersSidebar,
  FunnelStep,
  IntegrationVideo,
  ManageClientForOrderModal,
  ManageProductDiscountModal,
  PaymentLinksModal,
  SendPDFWithPaymentLinksModal,
  SendPaymentLinksModal,
  SendByModal,
  DeliveryProofModal,
  WebhookModal,
  WsCallClientListSidebarMC,
  ViewCallSidebar,
  CreateEditCustomField,
  OrderWsModalProductsMC,
  NewChat,
  FastAnswersModal,
  WhatsappFlowsModal,
  AttachFilesSidebar,
  LocationPickerSidebar,
  MiaSourcesResponseSidebar,
  CustomerAddressSidebar,
  CustomerEventSidebar,
  InboxScreenSidebar,
  NewsModal,
  OrderModal,
  PipedreamActions,
  SearchProductsModal,
  SelectCustomerModal,
  SelectQuoteTemplateModal,
  WsTemplatePreviewModalMC,
  MessageDetailSidebar,
  WhatsappFlowDetailModal,
  WhatsappFlowMappingModal,

  // MIA
  DetailModal,
  AssignmentsModal,
  BuyIntentionModal,
  ClientDataModal,
  CreateModal,
  CreateChatbotIAGuides,
  GeneralParametersModal,
  GoalModal,
  GlobalInstructionModal,
  GlobalInstructionToolsModal,
  IntentionTemplateModal,
  HandoffModal,
  HistoryDetailModal,
  ImproveGuideModal,
  InstructionsModal,
  InteractionExamplesModal,
  PlatformsModal,
  ProductModal,
  RestrictionsModal,
  SpecificInstructionsModal,
  StepByStepModal,
  MemoryModal,
  OutboundFollowUpsModal,
  WhatsappConsolidationModal,
  MessagingRuleUpgradeModal,
  MessagingRuleReassignModal,
  CalendarSidebarModuleMC
};

export default SIDEBARS;
